export enum EventType {
    
    Command = 0,
    
    DomainEvent = 1

}

export const EventTypeMetadata = {
    '0': {
        display: 'Command',
        value: 0
    },
    '1': {
        display: 'Domain Event',
        value: 1
    }
};
